'use client';

import { useRef, type FC, type ReactNode } from 'react';

import { cn } from '@/utils/cn';

import { useStickyTop } from './use-sticky-top';

/**
 * A block that pins from `lg` up — below the site header while it fits the
 * viewport, by its bottom edge when it is taller (see `useStickyTop`). Must be
 * a DIRECT child of the stretched column: sticky only travels within its parent.
 */
export const StickyPanel: FC<{ children: ReactNode; className?: string }> = ({ children, className }) => {
  const ref = useRef<HTMLDivElement>(null);
  const top = useStickyTop(ref);

  return (
    <div ref={ref} style={{ top }} className={cn('lg:sticky', className)}>
      {children}
    </div>
  );
};
